// import PropTypes from 'prop-types';
import styles from './DistibutorCard.module.scss';
import React from 'react';
import RawHtml from '../RawHtml/RawHtml';
import Flag from 'react-world-flags'

const DistibutorCard = ({ country, title, richText }) => {
    return (
        <div className={styles['DistibutorCard']}>
            <div className={styles['DistibutorCard__Container']}>
                <div className={styles['DistibutorCard__ImageTitleWrapper']}>
                    <div className={styles['DistibutorCard__ImageWrapper']}>
                        <Flag code={country} />
                    </div>

                    <h3 className={styles['DistibutorCard__Title']}>
                        {title}
                    </h3>
                </div>
                <div className={styles['DistibutorCard__InfoGrid']}>
                    <div className={styles['DistibutorCard__Row']}>
                        <RawHtml html={richText} />
                    </div>
                </div>
            </div>
        </div>
    );
};

DistibutorCard.propTypes = {};

DistibutorCard.defaultProps = {};

export default DistibutorCard;
